mutation DocumentPoolSubFolderCreate($input: DocumentPoolSubFolderCreateInput!) {
  documentPoolSubFolderCreate(input: $input) {
   documentPool
   {
    id,
    name
   }
  }
}